/**
 * PikLogo. The corrected PeopleiKnow mark: a navy rounded tile, a white inner
 * panel, and navy-ringed blue, yellow, green and purple nodes. `/logo.png` is
 * transparent outside the tile so it sits on the page background.
 *
 * Reusable brand mark for auth pages, onboarding, empty states, etc.
 * `className` controls sizing (Tailwind height util); defaults to a medium size.
 */
export function PikLogo({ className = 'h-16', testId = 'pik-logo' }) {
  return (
    <img
      src="/logo.png"
      alt="PeopleiKnow"
      className={`mx-auto object-contain ${className}`.trim()}
      data-testid={testId}
    />
  );
}

export default PikLogo;
